<template>
  <div id="app">
    <router-view class="content"/>
    <Loader v-if="$route.name !== 'LaunchScreen'"/>
    <ModalAchievement v-if="success || successBase"/>


    <BottomBarNavigation
        v-if="$route.name !== 'login' && $route.name !== 'LandingPage'  && $route.name !== 'LaunchScreen' && $route.name!=='rp'"/>
  </div>
</template>

<script>

// import GamesFunctions from "./service"
import BottomBarNavigation from "./components/Navigation/MainNavigation/BottomBarNavigation"
import Loader from "./components/Loader/Loader"
import ModalAchievement from "./components/Modals/Modal/ModalAchievement"
import {store} from './store/store.js'
import {mapActions, mapState} from "vuex";


export default {
  name: 'app',
  data() {
    return {}
  },
  components: {
    BottomBarNavigation,
    Loader,
    ModalAchievement
  },
  mounted() {
    // main()
    // GamesFunctions.checkGames()
    if (localStorage.getItem('user')) {
      toggleLoader()
      this.getUser(JSON.parse(localStorage.getItem('user')).id)
      store.state.user = JSON.parse(localStorage.getItem('user'))
      store.state.masks = JSON.parse(localStorage.getItem('masks'))
    }


  },
  updated() {


  },
  methods: {
    ...mapActions([
      'getUser',
    ]),
  }
  ,
  computed: {
    ...mapState(['success', 'successBase'])
  },


}
</script>

<style>

body {
  display: grid;
  grid-template-rows: auto;
  justify-items: center;
}

body, html {
  margin: 0;
  height: 100vh;
}

#app {

  width: 100%;
  height: calc(100vh - env(safe-area-inset-top));
  margin-top: env(safe-area-inset-top);
}

#deviceready {
  height: 100%;
}

.content {
  /*margin-top:80px;*/
}


.qrcode-stream-overlay {
  height: 50% !important;
  width: 50% !important;
  border: 2px solid #00d6ff;
  border-radius: 10px;
  left: calc(50% - 25%) !important;
  top: calc(50% - 35%) !important;
}

.qrcode-stream-overlay:before {
  position: absolute;
  display: block;
  content: "SCANNEZ UN TATOUAGE";
  color: var(--main-color);
  font-family: var(--main-title-font);
  font-size: 30px;
  font-weight: 200;
  top: 10px;
  text-align: center;
  width: 100%;
}


@media screen and (max-width: 750px) {
  .qrcode-stream-overlay {
    height: 50% !important;
    width: 80% !important;
    border: 2px solid #00d6ff;
    border-radius: 10px;
    overflow: hidden;
    left: 10% !important;
    top: calc(50% - 25%) !important;

  }


  .header {
    padding-top: env(safe-area-inset-top) !important;
  }
}

.qrcode-stream-camera {
  height: 100vh !important;

}


.tabs-content .header {
  display: none;
}

</style>
